export class ExcluirCertificado {
    idCertificado: number;
    senha: string;
    otp: string;
}